import { Location } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Chats, Message } from './shared/chats.model';
import { ChatsService } from './shared/chats.service';
import * as moment from 'moment';
@Component({
  selector: 'app-chat-page',
  templateUrl: './chats.component.html',
  styleUrls: ['./chats.component.scss']
})
export class ChatsComponent implements OnInit {
  @ViewChild('scrollAuto') scrollAuto: ElementRef;
  public chat: Chats;
  public chatId: string;
  public asTs;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ChatsService,
    private _location: Location
  ) { }

  ngOnInit() {
    this.route.params
      .map(p => {
        this.chatId = p['chatId'];
        return p.chatId
      })
      .filter(id => !!id)
      .do(this.chat = null)
      .flatMap(id => this.service.get(id))
      .subscribe((data: Chats) => {
        this.asTs = moment(new Date(data.createdAt)).format('LL')
        this.chat = data;
      });
  }
  goBack = () => this._location.back();
}




// WEBPACK FOOTER //
// /ng-app/src/app/chats/chats.component.ts